module.exports = __webpack_public_path__ + "img/thai.d33f6bbb.jpg";